@if (currentUser.assumeRawUserId) {
  <div class="assume">
    <button
      mat-mini-fab
      appTooltip="Arrêter la session de {{ currentUserDisplay }}"
      (click)="confirmStopAssume()"
      color="warn"
    >
      <mat-icon>pan_tool</mat-icon>
    </button>
  </div>
}
